import React from "react";

const ICMS = () => {
  return (
    <div style={{ padding: "2rem" }}>
      <h1>Rota /icms funcionando ✅</h1>
    </div>
  );
};

export default ICMS;